// Resolve a notification's deep-link target from its `data` payload. Keyed on
// the data ids the dispatchers carry (orderId / reservationId / sessionId), so
// it's robust to new notification types. Returns null when there's nothing to
// open (the row still marks read; no navigation).
export function notificationDeepLink(data: Record<string, unknown>): string | null {
  const str = (v: unknown): string | null => (typeof v === 'string' && v.length > 0 ? v : null);

  const orderId = str(data.orderId);
  if (orderId) return `/orders/${orderId}`;

  const reservationId = str(data.reservationId);
  if (reservationId) return `/reservations/${reservationId}`;

  const sessionId = str(data.sessionId);
  if (sessionId) return `/tables/session/${sessionId}`;

  return null;
}
